export default "dist/7655b042135598d8cc8dd71640c7efb7.ttf";